import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import styles from "./Home.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { Link } from "react-router-dom";
import ERPIMG from "../../assets/erp.jpg";
import ObeImg from "../../assets/obe_bg2.jpg";
import DigitalImg from "../../assets/Nav_bar_imgs/digital_evaluation.png";
import NaacImg from "../../assets/Nav_bar_imgs/NAAC.png";
import NirfImg from "../../assets/Nav_bar_imgs/nirf.png";
import IQACIMg from "../../assets/home_images/iqac_img.jpg";
import SmartImg from "../../assets/home_images/smartface.jpg";
import DWalletImg from "../../assets/home_images/digitalWallet_img.png";
import "./ModuleNew.css";

const Modules = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 1000); // Simulate data fetching
    AOS.init({ offset: 200, duration: 1000, easing: "ease-in-out", delay: 200 });
  }, []);

  const Module = [
    { name: "ERP", contant: "Transform academic management with Aspiron's ERP software.", link: "/erp", img: ERPIMG },
    { name: "Digital Evaluation", contant: "Streamline exam management with Aspiron's digital evaluation.", link: "/exam", img: DigitalImg },
    { name: "OBE", contant: "Experience transformative education with Aspiron's OBE software.", link: "/obe", img: ObeImg },
    { name: "NAAC", contant: "Partner with Aspiron for excellence in education.", link: "/naac", img: NaacImg },
    { name: "NIRF", contant: "Aspiron emphasizes the importance of educational recognition.", link: "/nirf", img: NirfImg },
    { name: "IQAC", contant: "IQAC drives quality improvement in institutional performance.", link: "/iqac", img: IQACIMg },
    { name: "SMART ATTENDANCE", contant: "Prioritize efficient attendance tracking with Aspiron.", link: "/smart", img: SmartImg },
    { name: "Digital Wallet", contant: "Digital Wallet offers seamless integration and expert support.", link: "/wallet", img: DWalletImg },
  ];

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <div className="slick-next" />,
    prevArrow: <div className="slick-prev" />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
    <div className={styles.modules}>
      <div className={styles.header}>
        {/* <img src={ProductsImg} alt="Products" className={styles.headerImage} /> */}
        <div className={styles.headerText}>
          <h1>
            <strong>Innovative</strong> Solutions
            <br />
            <strong>for a Smarter</strong> Tomorrow
          </h1>
          <a href="https://calendly.com/aspiron-technologies1/30min" target="_blank" rel="noopener noreferrer">
            <button className={styles.headerButton}> <span class="text">Get Demo</span></button>
          </a>
        </div>
      </div>
      <div className={styles.slider}>
        {isLoaded ? (
          <Slider {...settings}>
            {Module.map((each, index) => (
              <div key={index} className={styles.sliderItem}>
                <Link to={each.link} className={styles.link}>
                  <div className={styles.card}>
                    <img src={each.img} alt={each.name} className={styles.cardImage} />
                    <p className={styles.cardContent}>{each.contant}</p>
                    <ArrowCircleRightIcon className={styles.cardIcon} />
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
  );
};

export default Modules;
